import { Component, HostListener, OnInit, ViewChild } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Dialog } from "primeng";
import { CallCenterService } from "src/app/services/call-center.service";
import { environment } from "src/environments/environment";
// import { CallCenterInboundCallComponent } from '../call-center-inbound-call/call-center-inbound-call.component';
import { CallCenterInboundCallComponent } from "./../../call-center/call-center-inbound-call/call-center-inbound-call.component";

@Component({
  selector: "app-call-center-dailer",
  templateUrl: "./call-center-dailer.component.html",
  styleUrls: ["./call-center-dailer.component.scss"],
})
export class CallCenterDailerComponent implements OnInit {
  constructor(
    private callCenterService: CallCenterService,
    private domSanitizer: DomSanitizer
  ) { }
  dailerIframeURL: string = "";
  ngOnInit() {
    this.getLoginUser_CurrentPrivileges();
    this.initiateEventListener();
    this.dailerIframeURL = environment.dialerIframeUrl;
    console.log("Dailer URL: ", this.dailerIframeURL);
    //this.sanitizeGivenURL(this.dailerIframeURL)
  }

  sanitizeGivenURL(givenUrl) {
    // return this.domSanitizer.bypassSecurityTrustResourceUrl('givenUrl');
  }

  isCallCenterPerson: boolean = false;
  public getLoginUser_CurrentPrivileges() {
    let currentUser: any = JSON.parse(localStorage.getItem("LOGGED_USER_INFO"));
    if (
      currentUser.roleName == "Call Center" ||
      currentUser.roleName == "Admin" ||
      currentUser.roleName == "Call Center Admin" ||
      currentUser.roleName == "Super Admin"
    ) {
      this.isCallCenterPerson = true;
    }
  }

  display: boolean = false;
  displayPosition: boolean;

  position: string = "bottomright";

  showDialog() {
    this.display = true;
  }

  initiateEventListener() {
    window.addEventListener(
      "message",
      (e) => {
        console.log(
          "CRM IFrame Parent Window JS",
          environment.dialerParentURL,
          "==",
          e.origin
        );
        if (e.data.authCRMId == "ahllcrm@63") {
          this.maximizableWindow();
          let mobileNumber = e.data.mobileNumber
            ? e.data.mobileNumber.replace(/\D/g, "").slice(-10)
            : "";
          if (mobileNumber && mobileNumber.length >= 10) {
            //e.origin == "http://localhost:4200" && e.data == "CallFunctionA"
            this.openDialerRightWindow(mobileNumber,
              e.data.crmNumber ? e.data.crmNumber : null,
              e.data.didNumber.length > 4 ? e.data.didNumber.slice(-4) : e.data.didNumber,
            );
          }
        }
      },
      false
    );
  }

  openDialerRightWindow(mb, crmNumber,didNumber) {
    let data = {
      patientMobileNumber: mb,
      agentId: localStorage.getItem('username'),
      crmNumber: crmNumber,
      didNumber : didNumber
    };
    localStorage.setItem("CurrentInBoundCallDetails", JSON.stringify(data));
    this.callCenterService.triggerInboundCallComponent(data);
  }

  // @HostListener('window:message', ['$event'])
  // onMessage(e) {
  //   debugger
  //   console.log("CRM IFrame Parent Window");
  //  // alert('Reached iframe parent component HOst');
  //   // if (e.origin != environment.dialerParentURL) { // set your parent origin
  //   //   return false;
  //   // }
  //   if (e.data.openCRMDialerIframe && e.data.authCRMId == "ahllcrm@63") {
  //     this.maximizableWindow()
  //     let mobileNumber = e.data.mobileNumber ? e.data.mobileNumber.replace(/\D/g, '').slice(-10) : "";
  //     if (mobileNumber && mobileNumber.length >= 10) { //e.origin == "http://localhost:4200" && e.data == "CallFunctionA"
  //       this.openDialerRightWindow(mobileNumber);
  //     }
  //   }
  // }

  isWindowFullMaximized: boolean = false;
  isWindowMaximized: boolean = false;
  __modalCustomClass = { width: "25vw", height: "3vw" };
  minimizableWindow() {
    this.isWindowMaximized = false;
    this.isWindowFullMaximized = false;
    this.__modalCustomClass = { width: "25vw", height: "3vw" };
  }
  maximizableWindow() {
    this.isWindowFullMaximized = true;
    this.isWindowMaximized = true;
    this.__modalCustomClass = { width: "45vw", height: "53vw" };
  }
  fullMaximizableWindow() {
    this.isWindowFullMaximized = true;
    alert();
  }
}
